import { render, staticRenderFns } from "./SimulationCharacter.vue?vue&type=template&id=3c50c8fa&scoped=true"
import script from "./SimulationCharacter.vue?vue&type=script&lang=js"
export * from "./SimulationCharacter.vue?vue&type=script&lang=js"
import style0 from "./SimulationCharacter.vue?vue&type=style&index=0&id=3c50c8fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c50c8fa",
  null
  
)

export default component.exports